import script from "./HelpText.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpText.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__